const ScoreBoard = ({ score }) => {
    return (
      <div className="score-board" style={{color:"white"}}>
        <h2>{score}</h2>
      </div>
    )
  }
  
  export default ScoreBoard